/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { Route } from 'vue-router';

import platform from '@/shared/utils/platform';
import RouterHelper from '@/shared/utils/routerHelper';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';
import { goBackPreviousPage } from '@/shared/utils/goBack';
import { VerifyTypeEnum } from '@/api/verify-credit/types';
import { setIosBouncesEable } from '@/api/native';
import { OpenVerifyPageMode, VerifySceneEnum, ResolveVerifyStageEnum } from '@/shared/verify-credit-controller/types';
import {
  JUMP_VERIFY_OPTIONS_CACHE,
  RESOLVE_VERIFY_FOR_SCENES,
  verifySceneMapping,
  getPresentationConfig,
  RESOLVE_UNFINISHED_VERIFY_FOR_SCENES,
} from '@/shared/verify-credit-controller';
import { setNativeNavBar, setPageTitle, setStatusBarCompatPlatform } from '@/api/native/utils';
import { ubtSendError } from '@/shared/utils/ubt';
import { checkUseOcrExperiment } from '@/shared/tools/ocr/utils/check';
import { showLivenessSavePopup } from '@/components/liveness-save-popup';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import LoadingPage from '@/components/loading-page';
import { getUserInfoProgress } from '@/api/homeV2Status';
import { UserInfoProgress } from '@/api/homeV2Status/types';
import { commonDispatchPreRender, currentIsPrerenderRunning } from '@/shared/utils/prerenderHelper';
import { agreementService } from '@/service/confirm-agreements';
import { showIdentityBackPopup } from '@/components/identity-back-popup';
import store from '@/store';
import { dispatchActions } from '@/store/dispatchActions';
import { initActivityModulesConfig, ActivityPageTypeEnums } from '@/shared/activity-undertake';
import IdentityDispatch from './components/verify-stages/identityDispatch/index.vue';
import Liveness from './components/verify-stages/liveness';
import NavBar from './components/nav-bar/index.vue';
import { continueCreditApplyTask, queryTaskProduct, getUserInfoProcessConfig } from '../../api/verify-credit';
import {
  HeaderNoticeTypeEnum, NavBarConfig, VerifyEntireTypeEnum, VerifyStageContext,
  VerifyStageEnum, transformLinkType,
} from './types';

import {
  customSceneUIControls,
  DEFAULT_PAGE_ID,
  getCurrentIsCustomScene, getCustomSceneVerifyStageConfig,
  getStageUbtConfig, isDependUserInfoProgressScene,
  isNeedCheckIdentityClarityScore,
} from './const';
import { formatExternalLinkJumpRouterQuery } from './utils';
import fieldsComponentsAb from './fields.ab';
import {
  Contacts,
  ExpContacts,
  Profile,
  ExpProfile,
  TwoFactor,
  HeaderNotice,
} from './async-components';
import { verifyCreditDispatchActions } from './store';
import { genNavBarConfig, VerifyStageTitle } from './navbar';
import { checkShowIdentityBackPopup } from './back-popup';

import style from './index.module.scss';
import './verify.theme.blue.scss';

@Component({
  name: 'VerifyCredit',
})
export default class VerifyCredit extends Vue {
  /** 核验进入标识 */
  @Prop(String) readonly jumpId!: string;

  // 响应式最高额度文案
  private maxQuotaText = useMaxQuotaText();

  /** 核验场景值(外部流程) */
  @Prop(String) readonly scene!: VerifySceneEnum;

  /** 打开场景 */
  @Prop(String) readonly openMode!: OpenVerifyPageMode;

  /** 各个渠道id(以“,”隔开) */
  @Prop(String) readonly commodityIds!: string;

  /** 流程id */
  @Prop(String) readonly creditId!: string;

  /** 当前验证步骤，用于内部回跳场景使用，如 h5活体成功后，回跳到h5活体步骤进行结果回调 */
  @Prop(String) readonly currentStage!: VerifyStageEnum;

  /** 整合后的commodityIds */
  private lastCommodityIds: string[] = [];

  /** 页面是否正在加载中 */
  private isPageLoading = true;

  /** 是否是ocr后置流程，服务端返回标识 */
  private ocrAfter = false;

  /** 是否ocr照片完整，服务端返回标识 */
  private ocrComplete = false;

  /** 是否是ocr后置提现流程，服务端返回标识 */
  private get ocrAfterLoan(): boolean {
    return !!(store.state.base.businessInfoExtra?.userInfo?.ocrAfterLoan
      || this.queryParams?.ocrAfterLoan);
  }

  private get navBarConfig(): NavBarConfig {
    return genNavBarConfig(this.processVerifyStage as VerifyStageEnum);
  }

  /** 验证成功回调方法 */
  private get successCb() {
    const optionsCache = JUMP_VERIFY_OPTIONS_CACHE[this.jumpId];

    return (optionsCache && optionsCache.successCb)
      || RESOLVE_VERIFY_FOR_SCENES[this.scene]
      || this.onBackToPreviousPage.bind(this);
  }

  /** 未完成验证流程回调方法 */
  private get unfinishedVerifyCb() {
    return RESOLVE_UNFINISHED_VERIFY_FOR_SCENES[this.scene] || null;
  }

  /** 场景附属参数 */
  private get queryParams() {
    const optionsCache = JUMP_VERIFY_OPTIONS_CACHE[this.jumpId] || {};

    /**
     * 进入验证流程的附属参数：queryParams
     * 1. 若是外部通过url跳转: (AppFinanceLoanH5项目、唤端流程)，则近似取 $route.query
     * 2. 若是内部通过jumpToVerifyCredit方法跳转：取controller方法设置缓存的queryParams数据
     */
    return optionsCache.queryParams || formatExternalLinkJumpRouterQuery(this.$route.query);
  }

  /** 验证失败回调方法 */
  private failCb: (() => void) | undefined;

  /** 检验场景值(内部处理类型) */
  private get verifyType(): VerifyTypeEnum | null {
    return verifySceneMapping(this.scene as string);
  }

  /** 用户资料填写状态 */
  private userInfoProgress: UserInfoProgress | null = null;

  /** 当前验证的步骤名称 */
  private processVerifyStage: VerifyStageEnum | null = null;

  /** 当前验证的步骤是否 最后一个 */
  private processIsLastVerify = false;

  /** 验证流程是否完成 */
  private isVerifyFlowComplete = false;

  /** 是否使用客户端OCR */
  private isUseClientOcr: boolean | null = null;

  private async setIsUseClientOcr() {
    this.isUseClientOcr = await checkUseOcrExperiment();
  }

  /** 链路类型：提现 or 授信 */
  private get verifyEntireType() {
    return transformLinkType(this.scene);
  }

  /** 是否为编辑模式：样式定制、挽留弹窗关闭... */
  private get currentIsModifyMode() {
    return this.verifyEntireType === VerifyEntireTypeEnum.MODIFY;
  }

  /** 进入极简流程、预授信-补充资料场景，使用 头部新样式 */
  private get isVerifyStageHeaderUINew() {
    return [
      VerifyTypeEnum.PRE_CREDIT_ADD_INFO,
      VerifyTypeEnum.ADD_INFO,
    ].includes(this.verifyType as VerifyTypeEnum);
  }

  /** 各步骤组件上下文(动态修改) */
  private verifyStageContext: VerifyStageContext = {
    requireSpouseInfo: false,
    lockSpouseInfo: false,
    requireNoSpouseInfo: false,
    lockNoSpouseInfo: false,
    requireContactsInfo: false,
  };

  private get currentStageIsIdCard() {
    return this.processVerifyStage === VerifyStageEnum.ID_CARD;
  }

  /** 是否是OCR页面及OCR扫描模式 */
  private get isOCRScanMode() {
    return this.currentStageIsIdCard && this.isUseClientOcr;
  }

  private get pageInAutoHeight() {
    return this.isOCRScanMode || this.processVerifyStage === VerifyStageEnum.TWO_ELEMENTS;
  }

  /** header通知栏的场景类型 */
  private get headerNoticeType() {
    return this.currentStageIsIdCard && this.userInfoProgress?.identityExpiresFor30 ? HeaderNoticeTypeEnum.IDENTITY_EXPIRES : '';
  }

  private setNativeNarbarTitle(title: string) {
    /** 更新meta属性的title，避免beforeResolve事件又设置一次标题 */
    this.$route.meta.title = title;

    if (!this.isImmerseNarbar) {
      setPageTitle(title);
    }
  }

  /** 是否开启 沉浸式导航栏模式 */
  private get isImmerseNarbar(): boolean {
    // popup打开方式，不展示沉浸式导航栏
    return (
      this.openMode !== OpenVerifyPageMode.POPUP_SHOW
      && platform.isHelloApp
      && customSceneUIControls.getIsUseImmerseNarbar(this.scene)
    );
  }

  /** 沉浸式导航栏模式，class样式 */
  private get immerseModeContainerClass(): unknown[] {
    // 使用本地响应式状态
    const { containerAdaptBgImage } = this.navBarConfig;

    return [
      style.containerImmerseMode,
      platform.isAndroid ? style.android : null,
      containerAdaptBgImage ? style.adaptUseImageNavbar : null,
    ];
  }

  private get commonUbtParams(): Dictionary<string> {
    return {
      scene: this.scene, type: this.verifyEntireType, commodityIds: this.commodityIds, processVerifyStage: this.processVerifyStage || '',
    };
  }

  public showInPopup(): void {
    /** 使用native导航栏时，同步设置标题栏（延迟避免冲突） */
    setTimeout(() => {
      this.setNativeNarbarTitle(this.processVerifyStage ? VerifyStageTitle[this.processVerifyStage] : '');
    }, 100);
  }

  public hideInPopup(): void {
    this.setNativeNarbarTitle('');
  }

  private onBackToPreviousPage(): void {
    goBackPreviousPage();
  }

  /** 用户验证记录，如本次已验证过：”基本信息“，当前验证”紧急联系人“，则：[userBase、contactInfo] */
  private verifyHistory: VerifyStageEnum[] = [];

  private setProcessVerify(
    verifyStage: VerifyStageEnum,
    isLast?: boolean,
  ): void {
    this.processVerifyStage = verifyStage;
    this.processIsLastVerify = isLast || false;
    this.verifyHistory.push(this.processVerifyStage);

    /** 更新标题栏 */
    this.setNativeNarbarTitle(VerifyStageTitle[this.processVerifyStage]);
    /** 更新页面ID */
    this.$route.meta.pageId = getStageUbtConfig(this.processVerifyStage).pageId || DEFAULT_PAGE_ID;
  }

  /** 查询用户的资料填写状态，有些特殊场景定制化 */
  private async initUserInfoProgress() {
    try {
      this.userInfoProgress = await getUserInfoProgress();
    } catch (err) {
      /** 因为不是主流程的必须，在此不抛出异常，阻断主流程的进行 */
      ubtSendError(`verify-credit-initUserInfoProgress-error:${(err as Error).message}`);
    }
  }

  /** 前端定制化场景，当前检验步骤设置 */
  private customSceneUpdateVerifyStage(isInitialize?: boolean): void {
    const stageList = getCustomSceneVerifyStageConfig(
      this.scene, this.queryParams, this.userInfoProgress,
    );

    if (!stageList || !stageList.length) {
      throw new Error(`getCustomSceneVerifyStageConfig config is error by the property of ${this.scene}`);
    }

    /**
     * 初始化校验步骤：
     * 1. 若是初次则取步骤配置列表[0]
     * 2. 若是活体回跳场景，则取url参数currentStage
     */
    if (isInitialize) {
      /** 若是活体验证成功回跳，则设置为活体（活体在自定义场景是最后步骤） */
      if (this.currentStage === VerifyStageEnum.BIO_AUTH) {
        this.setProcessVerify(
          this.currentStage,
          true,
        );
      } else {
        this.setProcessVerify(
          stageList[0],
          stageList.length === 1,
        );
      }
    } else {
      /** 验证完成当前步骤，决策下一步的处理 */
      const currentIdx = stageList.indexOf(
        this.processVerifyStage as VerifyStageEnum,
      );

      if (currentIdx >= stageList.length - 1) {
        /** 当前是最后一步，则设置状态完成 */
        this.isVerifyFlowComplete = true;
      } else {
        /** 取下一步校验步骤 */
        const nextStageIndex = currentIdx + 1;
        this.setProcessVerify(
          stageList[nextStageIndex],
          nextStageIndex === stageList.length - 1,
        );
      }
    }
  }

  /** 普通场景，请求服务端来控制检验步骤 */
  private async syncServerUpdateVerifyStage() {
    try {
      const data = await getUserInfoProcessConfig(this.verifyType || VerifyTypeEnum.ADD_INFO);
      const {
        currentPage, isLast, infoComplete, ocrAfter, ocrComplete,
      } = data || {};

      /** 更新服务端标识，用于后续接口入参传递 */
      this.ocrAfter = !!ocrAfter;
      this.ocrComplete = !!ocrComplete;

      if (infoComplete) {
        this.isVerifyFlowComplete = true;
      } else if (currentPage) {
        this.setProcessVerify(
          currentPage as VerifyStageEnum,
          isLast,
        );
      }
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  /** 渠道id同步服务端， 兜底上游前端渠道id取不到的场景 */
  private async initCommodityIds() {
    if (!this.commodityIds && this.creditId) {
      try {
        const { creditProducts } = await queryTaskProduct(this.creditId);

        if (creditProducts && creditProducts.length) {
          this.lastCommodityIds = creditProducts.map((it) => it.productId);
        }
      } catch (err) {
        ubtSendError(err as Error);
      }
    } else {
      this.lastCommodityIds = this.commodityIds ? String(this.commodityIds).split(',') : [];
    }
  }

  private async created() {
    /** 预渲染模式-不执行后续逻辑 */
    if (IS_PRERENDERING) return;

    /** Popup模式不使用沉浸式navbar */
    if (!this.isImmerseNarbar) {
      setNativeNavBar(true);
      setStatusBarCompatPlatform({ isShowStatusBar: true });
    } else {
      setNativeNavBar(false);
    }

    // 设置ios弹性滚动禁止
    setIosBouncesEable(false);
    // 编辑场景下-关闭挽留弹窗
    this.closeBackConfirmSetting();

    try {
      this.setIsUseClientOcr();
      /** 营销活动场景，完成配置读取后，更新活动相关展示 */
      initActivityModulesConfig(ActivityPageTypeEnums.VERIFY_CREDIT)
        .finally(verifyCreditDispatchActions.updateActivityConfigRelateDisplay);

      const asyncTasks = [
        /** 初始化commodityId */
        this.initCommodityIds(),
        /** 获取全局通用数据 */
        dispatchActions.base.getBusinessInfoExtra(),
        /** 初始化field新版版本AB分流 */
        fieldsComponentsAb.initFieldComponentsAbResult(),
      ];

      /** 设置当前用户的资料检验步骤 */
      if (getCurrentIsCustomScene(this.scene)) {
        /** 使用服务接口返回的资料进度，动态设置步骤 */
        if (isDependUserInfoProgressScene(this.scene)) {
          asyncTasks.push(this.initUserInfoProgress());
        }
        /** 异步请求任务同步执行，减少等待延迟 */
        await Promise.all(asyncTasks);

        this.customSceneUpdateVerifyStage(true);
      } else {
        if (isDependUserInfoProgressScene(this.scene)) {
          /** 初始化userInfoPorcess数据，但顺序无强制依赖 */
          asyncTasks.push(this.initUserInfoProgress());
        }
        asyncTasks.push(this.syncServerUpdateVerifyStage());
        /** 异步请求任务可同步执行，减少等待延迟 */
        await Promise.all(asyncTasks);
      }

      /** 等 verifyConfig 返回 标记完成以后，则直接触发“成功”回调 */
      if (this.isVerifyFlowComplete) {
        this.onResolveProcessVerify(undefined, ResolveVerifyStageEnum.INIT);
      } else {
        /** 未完成验证流程，处理未完成验证流程回调 */
        this.onResolveUnfinishedVerify();
      }
    } catch (err) {
      ubtSendError(err as Error);
    } finally {
      this.isPageLoading = false;
    }
  }

  private mounted() {
    if (IS_PRERENDERING) {
      commonDispatchPreRender();
    }
  }

  private beforeDestroy(): void {
    /** 若验证失败，则执行failCb回调 */
    if (!this.isVerifyFlowComplete && this.failCb) {
      try {
        this.failCb.call(this.$router);
      } catch (err) {
        ubtSendError(err as Error);
      }
    }
    /** 清空校验设置缓存 */
    JUMP_VERIFY_OPTIONS_CACHE[this.jumpId] = undefined;
  }

  private onUpdateVerifyStageContext(context?: Dictionary | VerifyStageContext) {
    if (context) {
      this.verifyStageContext = {
        ...this.verifyStageContext,
        ...context,
      };
    }
  }

  /** 完成当前验证步骤 */
  private async onResolveProcessVerify(
    context?: VerifyStageContext,
    stage?: ResolveVerifyStageEnum,
  ) {
    try {
      this.onUpdateVerifyStageContext(context);
      this.ubtExposeResolveStage();

      /** 资料补充完成后，继续授信申请 */
      if (this.processIsLastVerify && this.verifyEntireType === VerifyEntireTypeEnum.CREDIT) {
        await continueCreditApplyTask();
      }

      /** 决策是否已完成 or 下一检验步骤 */
      if (getCurrentIsCustomScene(this.scene)) {
        this.customSceneUpdateVerifyStage();
      } else if (stage !== ResolveVerifyStageEnum.INIT) {
        /** 非页面初始化场景，需要请求服务获取-下一阶段的校验步骤 */
        await this.syncServerUpdateVerifyStage();
      }

      if (this.isVerifyFlowComplete && this.successCb) {
        if (this.openMode === OpenVerifyPageMode.POPUP_SHOW) {
          // 若是popup场景, 调用resolve，关闭popup
          this.$emit('resolve');
        }

        this.successCb.call(this.$router, {
          commodityIds: this.lastCommodityIds.join(','),
          creditId: this.creditId,
        }, stage);
      }
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  /** 未完成验证流程检查回调 */
  private onResolveUnfinishedVerify() {
    if (this.unfinishedVerifyCb) {
      this.unfinishedVerifyCb.call(this.$router, {});
    }
  }

  private onUbtClickSubmit() {
    if (this.processVerifyStage) {
      this.$ubtPageButtonNew(getStageUbtConfig(this.processVerifyStage).buttonName || '', this.commonUbtParams);
    }
  }

  private onUbtExposeModule() {
    if (this.processVerifyStage) {
      this.$ubtModuleExposeNew(getStageUbtConfig(this.processVerifyStage).exposeName || '', this.commonUbtParams);
    }
  }

  private ubtExposeResolveStage() {
    this.$ubtModuleExposeNew('finance_loan_verifyCredit_resolveStage', this.commonUbtParams);
  }

  private renderHeader() {
    return (
      <div class={ [style.headerBox, 'js-verify-creadit-header']}>
        <HeaderNotice
          sceneType={this.headerNoticeType}
          seamless={ this.isOCRScanMode }
        />
      </div>

    );
  }

  private renderVerifyStage() {
    const verifyComponentProps = {
      attrs: {
        processIsLastVerify: this.processIsLastVerify,
        verifyScene: this.scene,
        commodityIds: this.lastCommodityIds,
        openMode: this.openMode,
        verifyEntireType: this.verifyEntireType,
        verifyStageContext: this.verifyStageContext,
        queryParams: this.queryParams,
        isVerifyStageHeaderUINew: this.isVerifyStageHeaderUINew,
        ocrAfter: this.ocrAfter,
        ocrAfterLoan: this.ocrAfterLoan,
        ocrComplete: this.ocrComplete,
        isLoanProcess: this.verifyEntireType === VerifyEntireTypeEnum.LOAN,
      },
      on: {
        resolveProcessVerify:
          (context?: VerifyStageContext) => this.onResolveProcessVerify(
            context,
            ResolveVerifyStageEnum.OPERATION_COMPLETE,
          ),
        backPrevious: () => this.onBackToPreviousPage(),
        updateVerifyStageContext:
          (context: VerifyStageContext) => this.onUpdateVerifyStageContext(context),
        ubtClickSubmit: () => this.onUbtClickSubmit(),
        ubtExposeModule: () => this.onUbtExposeModule(),
      },
    };

    /** 根据AB实验，灰度、控量 线上实际应用新版本的组件 */
    const useNewComponents = fieldsComponentsAb.getCachedResult();

    switch (this.processVerifyStage) {
      case VerifyStageEnum.CONTACT_INFO:
        return useNewComponents
          ? <ExpContacts {...verifyComponentProps} />
          : <Contacts {...verifyComponentProps} />;
      case VerifyStageEnum.ID_CARD:
        return (
          <IdentityDispatch
            verifyScene={this.scene}
            verifyEntireType={this.verifyEntireType}
            isEditAction={this.currentIsModifyMode}
            showSaveConfirm={this.scene === VerifySceneEnum.PERSONAL_IDENTITY_MODIFY}
            isCheckIdentityClarityScore={isNeedCheckIdentityClarityScore(this.scene)}
            processIsLastVerify={verifyComponentProps.attrs.processIsLastVerify}
            ocrAfter={this.ocrAfter}
            ocrAfterLoan={this.ocrAfterLoan}
            isLoanProcess={verifyComponentProps.attrs.isLoanProcess}
            onResolveProcessVerify={verifyComponentProps.on.resolveProcessVerify}
          />
        );
      case VerifyStageEnum.BIO_AUTH:
        return <Liveness {...verifyComponentProps} style={{ flex: 1 }} />;
      case VerifyStageEnum.USER_BASE:
        return useNewComponents
          ? <ExpProfile {...verifyComponentProps} />
          : <Profile {...verifyComponentProps} />;
      case VerifyStageEnum.TWO_ELEMENTS:
        return <TwoFactor {...verifyComponentProps} />;

      default:
        return null;
    }
  }

  private render() {
    const isRenderLoading = IS_PRERENDERING || (currentIsPrerenderRunning() && this.isPageLoading);

    return (
      <div class={[
        style.page,
        this.pageInAutoHeight && style.heightAuto,
        getPresentationConfig().theme,
      ]}>
        {isRenderLoading && <LoadingPage pageId="finance_personal_loadingPage" />}
        {this.isImmerseNarbar && <NavBar config={this.navBarConfig} />}
        <div class={[
          style.container,
          this.isImmerseNarbar && this.immerseModeContainerClass,
          (isRenderLoading || this.isPageLoading) && style.hidden,
          'js-verify-credit',
        ]}>
          {this.renderHeader()}
          {this.renderVerifyStage()}
        </div>
      </div>
    );
  }

  /** 是否已显示活体挽留弹窗 */
  private hasShowLivenessSavePopup = false;

  /** 判断是否需要显示活体挽留弹窗，如果需要则展示 */
  private checkAndShowLivenessSavePopup(next: (...d: unknown[]) => void) {
    if (!this.hasShowLivenessSavePopup
      && this.openMode === OpenVerifyPageMode.ROUTER_JUMP
      && this.processVerifyStage === VerifyStageEnum.BIO_AUTH
      && [
        VerifyEntireTypeEnum.CREDIT,
        VerifyEntireTypeEnum.LOAN,
      ].includes(this.verifyEntireType)
    ) {
      const title = this.verifyEntireType === VerifyEntireTypeEnum.CREDIT ? `只差一步！最高可借${this.maxQuotaText.value}` : '只差一步！立刻提现成功';
      showLivenessSavePopup(
        title,
        this.verifyEntireType === VerifyEntireTypeEnum.CREDIT ? '提现环节' : '授信环节',
      ).catch(() => {
        this.hasShowLivenessSavePopup = true;
        next();
      });

      return true;
    }

    return false;
  }

  /** “活体验证”步骤-是否已命中“退出挽留弹窗”疲劳度 */
  private getLivenessShouldLeave(): boolean {
    return this.hasShowLivenessSavePopup && this.processVerifyStage === VerifyStageEnum.BIO_AUTH;
  }

  /** back挽留弹窗-前置设置(定制场景无需展示) */
  private closeBackConfirmSetting() {
    const { closeBackConfirmDialog } = this.queryParams;

    if (this.currentIsModifyMode || closeBackConfirmDialog) {
      RouterHelper.setBackConfirm(false);
    }
  }

  private identityBackPopupOnceEnterTired = false;

  private async beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    const isBack = RouterHelper.isBack();
    /** 退出资料页，不触发-默认的挽留弹窗拦截 */
    const doLeave = () => {
      RouterHelper.setBackConfirm(false);
      next();
    };
    /** 拦截离开页面 */
    const blockLeave = () => {
      RouterHelper.resetLastPopState();
      RouterHelper.useNextFalse(next);
    };
    // 回退场景 展示挽留弹窗
    if (isBack) {
      const { closeBackConfirmDialog } = this.queryParams;

      if (this.currentIsModifyMode || closeBackConfirmDialog || this.getLivenessShouldLeave()) {
        RouterHelper.setBackConfirm(false);
        next();
      } else if (this.checkAndShowLivenessSavePopup(next)) {
        blockLeave();
      } else if ((this.ocrAfter || this.ocrAfterLoan) && this.currentStageIsIdCard) {
        try {
          if (!this.identityBackPopupOnceEnterTired && await checkShowIdentityBackPopup()) {
            this.identityBackPopupOnceEnterTired = true;
            /** 展示身份证回退挽留弹窗 */
            showIdentityBackPopup().catch(doLeave);
            /** 拦截离开 */
            blockLeave();
          } else {
            doLeave();
          }
        } catch (error) {
          /** 连续点击退出按钮，仅触发1次拦截请求逻辑，后续无效不作处理 */
        }
      } else {
        next();
      }
    } else {
      next();
    }
  }
}
